<template>
  <div class="footer">
    <b-container v-if="this.$router.currentRoute.name!='SearchGrid'">
      <div class="bottom-banner" cols="12" v-if="adsFooter">
        <a
          :href="adsFooter.website"
          target="_blank"
          id="imageFooter"
          v-if="!adsFooter.advertisment_location.google_on"
          @click="CLICK_BANNERADS(adsFooter.id)"
        >
          <b-img
            :src="adsFooter.image"
            class="img-card"
            style="max-width:100%; height:auto;"
            :alt="adsFooter.website?adsFooter.website:$t('advertiseWithUsAlt',{ site_name: $root.siteTitle})"
          ></b-img>
        </a>
         <!-- Footer -->
          <Adsense
            data-ad-test="false"
            v-else
            :in-style="isMobile?'':'display:inline-block;width:970px;height:250px'"
            :data-ad-client="$root.googleClientId"
            :data-ad-slot="adsFooter.advertisment_location.google_ad_key"
            :data-full-width-responsive="isMobile?'true':'false'"
            :data-ad-format="isMobile?'auto':'horizontal'"
          >
          </Adsense>
      </div>
    </b-container>

    <component :is="footerHtml" v-if="this.$router.currentRoute.name!='SearchGrid'" />

    <div v-if="showDialog" class="footer-button"
     :style="{'z-index': $router.history.current.name == 'SearchGrid'?'9':''}">
      <span @click="gotoAddListing" style="cursor: pointer; margin: 0 15px;font-size:14px;"
        >{{ $t("addListing.name") }}</span
      >
      <span style="cursor: pointer; margin: 5px 15px;font-size:14px;" 
       @click="showModal();GET_LIST_PROVINCES({take:100,page:1})" >{{ $t("footer.setAlert") }}</span
      >
      <b-modal
        id="modal-1"
        title="BootstrapVue"
        hide-header
        hide-footer
        centered
        size="lg"
      >
        <div class="m-4">
          <div>
            <h5>{{ $t("footer.addNewAlert") }}</h5>
            <div @click="hideModal" class="close-modal">
              <CloseIcon />
            </div>
          </div>
          <div class="dialog-form form-group mt-5">
            <div class="input-div mb-3 mr-2">
              <label style="width: 200px">{{ $t("footer.title") }}</label>
              <b-input
                ref="input"
                class="input-search"
                :placeholder="$t('footer.title')"
                v-model="alert.title"
                :class="{
                  'input-error': validateErrors ? validateErrors.title : false,
                }"
              ></b-input>
            </div>
            <div class="input-div mb-3">
              <label style="width: 200px">{{ $t("search.type") }}</label>
              <b-dropdown no-flip
                class="menu-dropdown"
                v-model="alert.listing_type"
                :class="{
                  'input-error': validateErrors
                    ? validateErrors.listing_type
                    : false,

                }"
              >
                <template v-slot:button-content>
                  <span>
                    {{ $t(alert.listing_type.name) }}
                    <ChevronDownIcon />
                  </span>
                </template>
                <b-dropdown-item
                  v-for="(value, key) in listing_type"
                  v-bind:key="key"
                  @click="alert.listing_type = value"
                  :value="value"
                  >{{ $t(value.name) }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <div class="input-div mb-3">
              <label style="width: 200px">{{ $t("addListing.details.selectProductCategory") }}</label>
              <div class="input-div">
                <b-dropdown no-flip
                  class="menu-dropdown "
                  v-model="alert.category"
                  :class="{
                    'input-error': validateErrors
                      ? validateErrors.category
                      : false,
                    'mr-2':alert.category?alert.category.id:false
                  }"
                >
                  <template v-slot:button-content>
                    <span>
                      {{ $t(alert.category.name) }}
                      <ChevronDownIcon />
                    </span>
                  </template>
                  <b-dropdown-item
                    v-for="(value, key) in categoriesOptions"
                    v-bind:key="key"
                    @click="alert.category = value"
                    :value="value"
                    >{{ $t(value.name) }}</b-dropdown-item
                  >
                </b-dropdown>

                <b-dropdown no-flip
                  class="menu-dropdown "
                  :class="{
                    'input-error': validateErrors
                      ? validateErrors.subCategory
                      : false,
                      'mr-2':alert.sub_category?alert.sub_category.id:false
                  }"
                  v-model="alert.sub_category"
                  v-if="
                    alert.category &&
                    subCategory.listing_category_children.length
                  "
                >
                  <template v-slot:button-content>
                    <span>
                      {{ $t(alert.sub_category.name) }}
                      <ChevronDownIcon />
                    </span>
                  </template>
                  <b-dropdown-item
                    @click="alert.sub_category = value"
                    v-for="(value,
                    key) in subCategory.listing_category_children"
                    v-bind:key="key"
                    :value="value"
                    >{{ $t(value.name) }}</b-dropdown-item
                  >
                </b-dropdown>

                <b-dropdown no-flip
                  class="menu-dropdown"
                  :class="{
                    'input-error': validateErrors
                      ? validateErrors.subSubCategory
                      : false,
                      
                  }"
                  v-model="alert.sub_sub_category"
                  v-if="
                    alert.category &&
                    subSubCategory.listing_category_children.length
                  "
                >
                  <template v-slot:button-content>
                    <span>
                      {{ $t(alert.sub_sub_category.name) }}
                      <ChevronDownIcon />
                    </span>
                  </template>
                  <b-dropdown-item
                    @click="alert.sub_sub_category = value"
                    v-for="(value,
                    key) in subSubCategory.listing_category_children"
                    v-bind:key="key"
                    :value="value"
                    >{{ $t(value.name) }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>
            <div class="input-div mb-3">
              <label style="width: 200px">{{ $t("addListing.details.province") }}</label>
                <b-dropdown no-flip
                  class="menu-dropdown "
                  :class="{
                    'input-error': validateErrors
                      ? validateErrors.state
                      : false,
                  }"
                >
                  <template v-slot:button-content>
                    <span>
                      {{
                        alert.state
                          ? $t(alert.state.name)
                          : $t("addListing.details.province")
                      }}
                      <ChevronDownIcon />
                    </span>
                  </template>
                  <template v-for="(province, key) in arrListProvince">
                    <b-dropdown-item
                      @click="
                        alert.state = province;
                      "
                      v-bind:key="key"
                    >
                      {{ $t(province.name) }}</b-dropdown-item
                    >
                  </template>
                </b-dropdown>
            </div>
            <google-map
              v-if="showMap"
              ref="mapRef"
              :center="{ lat: lat, lng: lng }"
              :zoom="12"
              style="width: 100%; height: 50vh"
              
              :options="{
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: true,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUI: true,
              }"
            >
             <gmap-circle 
             :draggable='true'
             :editable='false'
             :center="{ lat: lat, lng: lng }" 
             :radius="radius" 
             @center_changed="updateCircle('bounds', $event)"></gmap-circle>
            </google-map>
          </div>
          <div class="input-div mb-3" style="width: 100%; text-align: center">
            <b-button
              class="search-button"
              style="width: 150px"
              @click="checkForm()"
            >
              {{ $t("alerts.post") }}
            </b-button>
          </div>
        </div>
      </b-modal>
    </div>
    <div
      v-if="!isMobile && $router.history.current.name != 'AddListing'"
      class="mt-19 add-listing"
      :style="{bottom: $router.history.current.name == 'SearchGrid'?'88px':'',right:$router.history.current.name == 'SearchGrid'?'25px':'','z-index': $router.history.current.name == 'SearchGrid'?'9':''}"
    >
      <button
        id="addListing"
        type="button"
        class="btn btn-post btn-primary"
        style="
            box-shadow: rgba(0, 0, 0, 0.26) 0px 5px 4px 0px;
            border-radius: 40px;
            padding: 0 30px;
            width:100%;
            height: 58px;
            font-size: 20px;
            background: var(--projectPrimaryColor) !important;
						border-color: var(--projectPrimaryColor) !important;
            color:white;"
        @click="showDialog = !showDialog"
      >
        <svg
          focusable="false"
          viewBox="0 0 24 24"
          aria-hidden="true"
          role="presentation"
          class="icon-list-add"
          style="color: white; filter: invert(1)"
        >
          <path
            d="M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z"
          ></path>
        </svg>
        {{$t('ลงประกาศ')}}
      </button>
    </div>
    
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { gmapApi } from "vue2-google-maps";
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import CloseIcon from 'vue-material-design-icons/Close.vue';
export default {
  components: {
    ChevronDownIcon,
    CloseIcon
	},
  data() {
    return {
      radius:5000,
      map: null,
      showMap: false,
      showDialog: false,
      subCategory: { listing_category_children: [] },
      subSubCategory: { listing_category_children: [] },
      countError: 0,
      alert: {
        title: null,
        listing_type: { name: null, id: null },
        category: { name: null, id: null },
        sub_category: { name: null, id: null },
        sub_sub_category: { name: null, id: null },
        lat: this.markerLat,
        lng: this.markerLng,
        state: { name: null, id: null },
      },
      listing_type: [
        { name: this.$t('search.rent'), id: 1 },
        { name: this.$t('search.sale'), id: 2 },
      ],
      lat: 13.7563,
      lng: 100.5018,
      markerLat: null,
      markerLng: null,
      validateErrors: {},
      adsFooter: {
        website: "#",
        image: "",
        advertisment_location: {
          google_on: false
        }
      }
    };
  },
  props: {
    categoryId: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    if (document.cookie.indexOf("tr_cookies_partner=1") === -1) {
      console.log("if");
      this.show_cookie_consenst_div(true);
    }
  },
  created() {
    
    
    let locationId = 9;
    if (
      (this.$router.history.current.path == "/th/search/" ||
        this.$router.history.current.path == "/en/search/" ) &&
      ((this.dataSearch && this.dataSearch.id == 1) || this.categoryId == 1)
    ) {
      locationId = 14;
    }
    if (
      (this.$router.history.current.name == "ListingDetail") &&
      ((this.dataSearch && this.dataSearch.id == 1) || this.categoryId == 1)
    ) {
      locationId = 18;
    }
    if (
      (this.$router.history.current.path == "/th/search/" ||
        this.$router.history.current.path == "/en/search/" ) &&
      ((this.dataSearch && this.dataSearch.id == 2) || this.categoryId == 2)
    ) {
      locationId = 23;
    }
    if (
      this.$router.history.current.name == "ListingDetail" &&
      ((this.dataSearch && this.dataSearch.id == 2) || this.categoryId == 2)
    ) {
      locationId = 27;
    }
    if (
      (this.$router.history.current.path == "/th/search/" ||
        this.$router.history.current.path == "/en/search/")  &&
      ((this.dataSearch && this.dataSearch.id == 3) || this.categoryId == 3)
    ) {
      locationId = 32;
    }
    if (
      this.$router.history.current.name == "ListingDetail" &&
      ((this.dataSearch && this.dataSearch.id == 3) || this.categoryId == 3)
    ) {
      locationId = 36;
    }
    if (
      (this.$router.history.current.path == "/th/search/" ||
        this.$router.history.current.path == "/en/search/" ) &&
      ((this.dataSearch && this.dataSearch.id == 4) || this.categoryId == 4)
    ) {
      locationId = 41;
    }

    if (
      this.$router.history.current.name == "ListingDetail" &&
      ((this.dataSearch && this.dataSearch.id == 4) || this.categoryId == 4)
    ) {
      locationId = 45;
    }
    if(this.isMobile){
      locationId=49;
    }
    this.GETADS_FOR_PUBLIC_WEBSITE({
      id: locationId
    }).then(({ data }) => {
      if (data) {
        this.adsFooter = data;
      }
    });
  },
 
  mounted(){},
  computed: {
    ...mapGetters("CategoryController", ["dataSearch", "categoriesOptions"]),
    ...mapGetters("UserController", ["isMobile"]),
    ...mapGetters("AddListingController", ["arrListProvince"]),
    ...mapGetters('SiteConfigController', ['projectConfig']),
    ...mapState("AddListingController", [
      "arrListCategoryChildChild",
      "arrListCategoryChild",
    ]),

    google: gmapApi,
    footerHtml() {
      const template = this.projectConfig ? this.projectConfig.footer_html : ''
      return {
				template 
			};
    }

  },
  watch: {
    arrListCategoryChild(val) {
      if(this.showDialog){
        console.log("arrListCategoryChild", val);
        this.subCategory = val;
        this.$forceUpdate();
      }
    },
    arrListCategoryChildChild(val) {
      if(this.showDialog){
        console.log("arrListCategoryChildChild", val);
        this.subSubCategory = val;
        this.$forceUpdate();
      }
    },
    "alert.category": {
      handler: function (after, before) {
        console.log("alert.category_id", after);
        if(after.id){
        (this.subCategory = { listing_category_children: [] }),
          (this.subSubCategory = { listing_category_children: [] }),
          this.GET_CATEGORY_CHILD_BY_ID({ id: after.id, type: false });
        }
      },
      deep: true,
    },
    "alert.sub_category": {
      handler: function (after, before) {
        console.log("alert.category_id", after);
        if(after.id){
          this.GET_CATEGORY_CHILD_BY_ID({ id: after.id, type: true });
        }
      },
      deep: true,
    },
    'alert.state':{
       handler: function (after, before) {
        console.log("alert.category_id", after);
        if(after.id==1){
          this.showMap = true;
          this.initMap();
        }else{
          this.showMap = false;
          this.markerLat = null;
          this.markerLng = null;
        }
      },
      deep: true,
    }
  },
  methods: {
    ...mapActions("AddListingController", [
      "GET_LIST_PROVINCES",
      "GET_LIST_DISTRICTS",
      "GET_CATEGORY_CHILD_BY_ID",
      "USER_ADD_LISTING",
      "GET_LISTING_PREVIEW",
      "USER_UPDATE_LISTING",
      "USER_CONFIRM_LISTING",
    ]),
    ...mapActions("AdsController", [
      "GETADS_FOR_PUBLIC_WEBSITE",
      "CLICK_BANNERADS"
    ]),
    ...mapActions("AlertController", ["CREATE_ALERT"]),
     
    updateCircle(prop, value) {
     if (prop === 'bounds') {
       this.markerLat=value.lat();
       this.markerLng=value.lng();
      }
    },
    resetAlert(){
       this.alert={
        title: null,
        listing_type: { name: null, id: null },
        category: { name: null, id: null },
        sub_category: { name: null, id: null },
        sub_sub_category: { name: null, id: null },
        lat: this.markerLat,
        lng: this.markerLng,
        state: { name: null, id: null },
      }
    },
    initMap() {
      setTimeout(() => {
        this.$refs.mapRef.$mapPromise.then((map) => {
          this.map = map;
          map.panTo({ lat: this.lat, lng: this.lng });
        });
      }, 200);
    },
    createAlert() {
      
     
        if (this.countError) {
          this.makeToastError("Form is incomplete.",'danger');
          return;
        }
        let alert = {
          title: this.alert.title,
          listing_type: this.alert.listing_type.id,
          category_id: this.alert.category.id,
          sub_category_id: this.alert.sub_category.id,
          sub_sub_category_id: this.alert.sub_sub_category.id,
          lat: this.markerLat,
          lng: this.markerLng,
          province_id: this.alert.state.id,
        };
        this.$root.loading=true;
        this.CREATE_ALERT(alert).then((result) => {
          this.$root.$emit("bv::hide::modal", "modal-1");
          this.makeToastError(this.$t('alerts.createdSuccess'),'success');
          this.resetAlert();
          this.$root.loading=false;
        }).catch(err=>{
          this.makeToastError(this.$t('alerts.createdError'),'danger')
          this.$root.loading=false;
        });
        
    },
    hideModal(){
        this.$root.$emit("bv::hide::modal", "modal-1");
    },
    showModal(){
      if (this.$root.isAuthenticated) {
        this.$root.$emit("bv::show::modal", "modal-1");
      } else {
        this.openKhaosodLogin();
      }
    },
    gotoAddListing() {
      if (this.$root.isAuthenticated) {
        this.$router.push(this.$i18nRoute({ name: "add-listing" }));
      } else {
        this.openKhaosodLogin();
      }
    },
    makeToastError(text,variant) {
      this.$bvToast.toast(text, {
        title: text,
        variant: variant ,
        solid: true,
      });
    },
    openKhaosodLogin() {
      this.$root.signIn();
    },
    getPosition(ev) {
      this.markerLat = ev.latLng ? ev.latLng.lat() : ev.lat();
      this.markerLng = ev.latLng ? ev.latLng.lng() : ev.lng();
    },
    putMarker(ev) {
      this.markerLat = ev.latLng ? ev.latLng.lat() : ev.lat();
      this.markerLng = ev.latLng ? ev.latLng.lng() : ev.lng();
    },
    checkForm(e) {
      this.countError = 0;
      this.validateErrors = {};
      this.validateInputDynamic = [];
      this.isValidate = true;
      if (this.alert.title && this.alert.title.match(/[\u1000-\uFFFF]+/g)) {
        this.validateErrors[`title`] = true;
        this.countError++;
        this.makeToastError(this.$t('Marks or special characters are not allowed'),'danger');
        return;
      }
      if (!this.alert.title) {
        this.validateErrors[`title`] = true;
        this.countError++;
        return;
      }

      if (!this.alert.listing_type.id) {
        this.validateErrors[`listing_type`] = true;
        this.countError++;
      }
      if (!this.alert.category.id) {
        this.validateErrors[`category`] = true;
        this.countError++;
      }
      if (this.alert.category.id!=35&&!this.alert.sub_category.id) {
        this.validateErrors[`subCategory`] = true;
        this.countError++;
      }
      if (!this.alert.sub_sub_category.id == 34) {
        this.validateErrors[`subSubCategory`] = true;
        this.countError++;
      } else {
        this.validateErrors[`subSubCategory`] = false;
      }

      if (!this.alert.state) {
        this.validateErrors[`state`] = true;
        this.countError++;
      }
      if (this.alert.state.id == 1) {
        if (!this.markerLat && !this.markerLng) {
          this.validateErrors[`location`] = true;
          this.countError++;
        }
      }
      this.createAlert();
    },
    
  }
};
</script>
<style lang="scss">
@import "style";
</style>
